import { URL_API_PDULI } from "../../../general/init/url";
import { COUNSELOR_VAR_SERVER } from "../constants/SessionKonselingConstants";

export const API_POST_VALIDATION_SESSION_KONSELOR = () =>
  URL_API_PDULI + "/api/video-token/get-data";
export const API_GET_SESSION_KONSELING = (sessionId, typeUser) => {
  let n = "counselee";
  if (typeUser == COUNSELOR_VAR_SERVER) {
    n = "counselor";
  }
  return URL_API_PDULI + "/api/video-token/" + n + "/get-session/" + sessionId;
};

export const API_STOP_SESSION_KONSELING = (
  sessionId,
  typeUser,
  idServerRecord
) => {
  let n = "counselee";
  if (typeUser == COUNSELOR_VAR_SERVER) {
    n = "counselor";
  }

  return (
    URL_API_PDULI +
    "/api/video-token/" +
    n +
    "/stop-video-call/" +
    sessionId +
    "/" +
    idServerRecord
  );
};

export const API_POST_KONSELOR_SESSION = () =>
  URL_API_PDULI + "/api/video-token/counselor/suggestion";

export const API_GET_SESSION_KONSELOR = (session) =>
  URL_API_PDULI + "/" + session;

export const API_SET_END_SESSION_KONSELOR = (session) =>
  URL_API_PDULI + "/" + session;

export const API_GET_RESULT_SESSION_KONSELOR = (session) =>
  URL_API_PDULI + "/" + session;

export const API_POST_RESULT_SESSION_KONSELOR = (session) =>
  URL_API_PDULI + "/" + session;

export const API_GET_PDULI_AI_CHAT = (session) => URL_API_PDULI + "/" + session;

export const API_START_RECORD_PDULI = (typeUser) => {
  let n = "counselee";
  if (typeUser == COUNSELOR_VAR_SERVER) {
    n = "counselor";
  }

  return URL_API_PDULI + "/api/video-token/" + n + "/start-recording";
};
